<script lang="ts">
  import { loginUrl } from '../lib/api/http';
  import { DEV_TOKEN_LOGIN_PATH } from '../lib/api/server';
  import { session } from '../lib/state/session.svelte';
</script>

<div class="signin">
  <div class="signin-card">
    <div class="brand-dark">Changeling<span>&nbsp;/ review</span></div>
    <h1>Review pull requests,<br />block by block.</h1>
    <p class="muted">
      Changeling is a review front end for GitHub. Swap <code>github.com</code> for this host in any pull request URL and
      you get the same PR, the same comments and the same people. Everything you do is mirrored to GitHub.
    </p>
    <a class="btn primary big" href={loginUrl()} data-external>Sign in with GitHub</a>
    {#if session.config?.dev_token_login}
      <p class="small"><a href={DEV_TOKEN_LOGIN_PATH} data-external>Sign in with a token (dev)</a></p>
    {/if}
    <p class="muted small">
      You sign in through the Changeling GitHub App. You see exactly what GitHub would show you.
    </p>
  </div>
</div>
